import React, { Component } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import StorageConfig from "./StorageConfig";
import StorageListView from "./StorageListView";
import SATooltip from "../../components/common/SATooltip";

const STORAGE_MAIN_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  :root {
    --sm-font: 'DM Sans', system-ui, sans-serif;
    --sm-mono: 'DM Mono', monospace;
    --sm-surface: #ffffff;
    --sm-bg: #f5f4f1;
    --sm-sidebar: #ffffff;
    --sm-sidebar-text: #111110;
    --sm-sidebar-muted: #6b6b68;
    --sm-sidebar-border: rgba(0,0,0,0.08);
    --sm-sidebar-hover: rgba(0,0,0,0.04);
    --sm-sidebar-active: rgba(0,0,0,0.06);
    --sm-accent: #d97706;
    --sm-accent-bg: rgba(217,119,6,0.12);
    --sm-accent-text: #d97706;
    --sm-blue: #2563eb;
    --sm-blue-bg: rgba(37,99,235,0.08);
    --sm-text: #111110;
    --sm-muted: #6b6b68;
    --sm-border: rgba(0,0,0,0.08);
    --sm-border-strong: rgba(0,0,0,0.14);
    --sm-radius: 10px;
    --sm-radius-lg: 14px;
  }

  .sm-shell {
    font-family: var(--sm-font);
    display: flex;
    height: calc(100vh - 10px);
    background: var(--sm-bg);
    overflow: hidden;
  }

  /* ── Sidebar ── */
  .sm-sidebar {
    width: 260px;
    flex-shrink: 0;
    background: var(--sm-sidebar);
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--sm-sidebar-border);
    overflow: hidden;
  }

  .sm-sidebar-home {
    flex-shrink: 0;
    padding: 12px 14px 12px;
    border-bottom: 1px solid var(--sm-sidebar-border);
    background: linear-gradient(180deg, rgba(37,99,235,0.04) 0%, transparent 100%);
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .sm-sidebar-home .sm-sidebar-logo {
    margin-bottom: 0;
  }

  .sm-sidebar-home-link {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 9px 11px;
    border-radius: var(--sm-radius);
    border: 1px solid var(--sm-sidebar-border);
    background: var(--sm-sidebar);
    color: var(--sm-sidebar-text);
    font-family: var(--sm-font);
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.01em;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.12s, border-color 0.12s, box-shadow 0.12s, color 0.12s;
  }

  .sm-sidebar-home-link:hover {
    background: var(--sm-sidebar-hover);
    border-color: var(--sm-border-strong);
    color: var(--sm-text);
    text-decoration: none;
    box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  }

  .sm-sidebar-home-link:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37,99,235,0.18);
    border-color: rgba(37,99,235,0.35);
  }

  .sm-sidebar-home-ico {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: var(--sm-blue-bg);
    border: 1px solid rgba(37,99,235,0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sm-blue);
    font-size: 13px;
    flex-shrink: 0;
  }

  .sm-sidebar-home-meta {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
    text-align: left;
  }

  .sm-sidebar-home-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--sm-sidebar-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sm-sidebar-home-chev {
    margin-left: auto;
    font-size: 11px;
    opacity: 0.45;
    flex-shrink: 0;
  }

  .sm-sidebar-header {
    padding: 20px 18px 16px;
    border-bottom: 1px solid var(--sm-sidebar-border);
    flex-shrink: 0;
  }

  .sm-sidebar-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
  }

  .sm-sidebar-logo-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: var(--sm-accent);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 13px;
  }

  .sm-sidebar-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: var(--sm-sidebar-text);
    letter-spacing: -0.01em;
  }

  .sm-sidebar-add-btn {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 10px 12px;
    border-radius: var(--sm-radius);
    border: 1px solid var(--sm-sidebar-border);
    background: var(--sm-sidebar-hover);
    color: var(--sm-sidebar-text);
    font-family: var(--sm-font);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    letter-spacing: -0.01em;
  }

  .sm-sidebar-add-btn:hover {
    background: var(--sm-sidebar-active);
    border-color: var(--sm-border-strong);
  }

  .sm-sidebar-add-btn i {
    font-size: 11px;
    color: var(--sm-accent);
  }

  .sm-sidebar-section {
    padding: 14px 12px 8px;
    flex-shrink: 0;
  }

  .sm-sidebar-section-label {
    font-size: 10px;
    font-weight: 600;
    color: var(--sm-sidebar-muted);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 0 6px;
    margin-bottom: 6px;
  }

  .sm-sidebar-scroll {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(0,0,0,0.18) transparent;
  }

  .sm-sidebar-scroll::-webkit-scrollbar {
    width: 4px;
  }

  .sm-sidebar-scroll::-webkit-scrollbar-track {
    background: transparent;
  }

  .sm-sidebar-scroll::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.18);
    border-radius: 4px;
  }

  .sm-sidebar-nav {
    padding: 8px 12px;
    flex-shrink: 0;
    border-top: 1px solid var(--sm-sidebar-border);
  }

  .sm-sidebar-nav-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 8px;
    color: var(--sm-sidebar-muted);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.12s, color 0.12s;
    border: 1px solid transparent;
    width: 100%;
    background: transparent;
    font-family: var(--sm-font);
    letter-spacing: -0.01em;
  }

  .sm-sidebar-nav-item:hover {
    background: var(--sm-sidebar-hover);
    color: var(--sm-sidebar-text);
  }

  .sm-sidebar-nav-item.trash-active {
    background: rgba(239,68,68,0.10);
    border-color: rgba(239,68,68,0.15);
    color: #f87171;
  }

  .sm-sidebar-nav-item i {
    font-size: 13px;
    width: 16px;
    text-align: center;
    flex-shrink: 0;
  }

  .sm-sidebar-tip {
    padding: 10px 12px 16px;
    flex-shrink: 0;
  }

  .sm-sidebar-tip-box {
    padding: 10px 12px;
    border-radius: 8px;
    background: rgba(217,119,6,0.08);
    border: 1px solid rgba(217,119,6,0.15);
  }

  .sm-sidebar-tip-box p {
    margin: 0;
    font-size: 11.5px;
    line-height: 1.55;
    color: rgba(217,119,6,0.85);
    font-weight: 400;
  }

  .sm-sidebar-tip-box p strong {
    color: var(--sm-accent);
    font-weight: 600;
  }

  /* ── Main area ── */
  .sm-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: var(--sm-bg);
  }

  /* Top bar — single page header */
  .sm-topbar {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 20px 16px;
    background: var(--sm-surface);
    border-bottom: 1px solid var(--sm-border);
    flex-shrink: 0;
  }

  .sm-page-header-left {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .sm-header-home {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    margin-top: 2px;
    border-radius: var(--sm-radius);
    border: 1px solid var(--sm-border);
    background: var(--sm-bg);
    color: var(--sm-blue);
    text-decoration: none;
    transition: border-color 0.12s, background 0.12s, color 0.12s, box-shadow 0.12s;
  }

  .sm-header-home:hover {
    color: var(--sm-blue);
    border-color: var(--sm-border-strong);
    background: var(--sm-surface);
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    text-decoration: none;
  }

  .sm-header-home:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37,99,235,0.2);
    border-color: var(--sm-blue);
  }

  .sm-header-home i {
    font-size: 14px;
  }

  .sm-topbar-title {
    flex: 1;
    min-width: 0;
  }

  .sm-topbar-title h1 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--sm-text);
    letter-spacing: -0.03em;
    line-height: 1.2;
  }

  .sm-topbar-title p {
    margin: 0;
    font-size: 13px;
    color: var(--sm-muted);
    font-weight: 400;
    line-height: 1.45;
    margin-top: 4px;
    max-width: 560px;
  }

  .sm-message-toast {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px 12px;
    background: #f0fdf4;
    border: 1px solid rgba(34,197,94,0.2);
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
    color: #15803d;
    max-width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .sm-topbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .sm-view-toggle {
    display: flex;
    align-items: center;
    background: var(--sm-bg);
    border-radius: 8px;
    padding: 3px;
    border: 1px solid var(--sm-border);
  }

  .sm-view-toggle button {
    width: 30px;
    height: 28px;
    border-radius: 6px;
    border: none;
    background: transparent;
    color: var(--sm-muted);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    transition: background 0.12s, color 0.12s;
  }

  .sm-view-toggle button.active {
    background: var(--sm-surface);
    color: var(--sm-text);
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  }

  .sm-view-toggle button:hover:not(.active) {
    color: var(--sm-text);
    background: rgba(0,0,0,0.04);
  }

  .sm-expand-btn {
    height: 36px;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid var(--sm-border);
    background: var(--sm-surface);
    color: var(--sm-muted);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 12.5px;
    font-weight: 500;
    font-family: var(--sm-font);
    transition: border-color 0.12s, color 0.12s, background 0.12s;
    letter-spacing: -0.01em;
  }

  .sm-expand-btn:hover {
    color: var(--sm-text);
    border-color: var(--sm-border-strong);
    background: var(--sm-bg);
  }

  .sm-close-storage {
    height: 36px;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid var(--sm-border);
    background: var(--sm-surface);
    color: var(--sm-muted);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 12.5px;
    font-weight: 500;
    font-family: var(--sm-font);
    letter-spacing: -0.01em;
    text-decoration: none;
    transition: border-color 0.12s, color 0.12s, background 0.12s;
    flex-shrink: 0;
  }

  .sm-close-storage:hover {
    color: var(--sm-text);
    border-color: var(--sm-border-strong);
    background: var(--sm-bg);
    text-decoration: none;
  }

  .sm-close-storage:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(37,99,235,0.2);
    border-color: var(--sm-blue);
    color: var(--sm-text);
  }

  .sm-close-storage i {
    font-size: 12px;
    opacity: 0.85;
  }

  @media (max-width: 520px) {
    .sm-close-storage span { display: none; }
    .sm-close-storage { padding: 0 10px; }
  }

  /* Content area */
  .sm-content {
    flex: 1;
    padding: 16px 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .sm-content-panel {
    flex: 1;
    background: var(--sm-surface);
    border: 1px solid var(--sm-border);
    border-radius: var(--sm-radius-lg);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  /* Empty state */
  .sm-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    text-align: center;
    gap: 14px;
  }

  .sm-empty-icon {
    width: 64px;
    height: 64px;
    border-radius: 18px;
    background: var(--sm-bg);
    border: 1px solid var(--sm-border);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sm-muted);
    font-size: 22px;
    margin-bottom: 4px;
  }

  .sm-empty h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--sm-text);
    letter-spacing: -0.02em;
  }

  .sm-empty p {
    margin: 0;
    font-size: 13px;
    color: var(--sm-muted);
    max-width: 340px;
    line-height: 1.6;
  }

  .sm-btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    border-radius: 8px;
    background: var(--sm-sidebar);
    color: #fff;
    border: none;
    font-family: var(--sm-font);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    letter-spacing: -0.01em;
    transition: opacity 0.12s, transform 0.12s;
  }

  .sm-btn-primary:hover {
    opacity: 0.88;
    transform: translateY(-1px);
  }

  .sm-btn-primary i {
    font-size: 11px;
  }

  /* Sidebar collapsed (expanded content mode) */
  .sm-shell.expanded .sm-sidebar {
    display: none;
  }

  @media (max-width: 860px) {
    .sm-sidebar { display: none; }
  }
`;

class StorageMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: window.innerHeight,
            storageId: null,
            rootFolder: null,
            storageName: "",
            cloudType: "",
            openConfiguration: false,
            selectedData: {},
            defaultView: 1,
            trashFileFlag: false,
            prefixCurrent: null,
            messageInfo: "",
            expand: false,
        };
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
        const id = "sa-storage-main-styles-v2";
        if (!document.getElementById(id)) {
            const tag = document.createElement("style");
            tag.id = id;
            tag.textContent = STORAGE_MAIN_CSS;
            document.head.appendChild(tag);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ height: window.innerHeight });
    };

    onClickAddConfiguration = () => {
        if (!this.state.openConfiguration) {
            this.setState({ openConfiguration: true });
        }
    };

    selectViewType = (type) => {
        if (type !== undefined) {
            this.setState({ defaultView: type });
        }
    };

    _getStorageInfo = (item, root, prefix) => {
        this.setState({
            storageId: item.id,
            rootFolder: root,
            prefixCurrent: prefix !== null ? prefix : "",
            storageName: root !== null ? item.name : "Default",
            cloudType: item.provisionerType,
            trashFileFlag: false,
            messageInfo: "",
        });
    };

    _toggleopenConfiguration = () => {
        this.setState({ openConfiguration: false });
    };

    _setCommonMessage = (message) => {
        this.setState({ messageInfo: message }, () => {
            setTimeout(() => this.setState({ messageInfo: "" }), 10000);
        });
    };

    expandView = () => {
        this.setState({ expand: !this.state.expand });
    };

    _pageHeaderSubtitle = () => {
        const { storageId, trashFileFlag } = this.state;
        if (trashFileFlag) return "Review and restore items removed from this storage.";
        if (!storageId) return "Select a connection to get started";
        return "Browse and manage your files in full view";
    };

    render() {
        const { defaultView, expand, messageInfo, storageId, trashFileFlag } = this.state;

        return (
            <div className={`sm-shell${expand ? " expanded" : ""}`}>
                {/* ── Sidebar ── */}
                {!expand && (
                    <aside className="sm-sidebar">
                        <div className="sm-sidebar-home">
                            <div className="sm-sidebar-logo">
                                <div className="sm-sidebar-logo-icon">
                                    <i className="fa-solid fa-cloud" />
                                </div>
                                <span className="sm-sidebar-logo-text">Storage</span>
                            </div>
                        </div>
                        <div className="sm-sidebar-header">
                            <button
                                type="button"
                                className="sm-sidebar-add-btn"
                                onClick={this.onClickAddConfiguration}
                            >
                                <i className="fas fa-plus" />
                                <span>Add connection</span>
                            </button>
                        </div>

                        <div className="sm-sidebar-section">
                            <div className="sm-sidebar-section-label">Connections</div>
                        </div>

                        <div className="sm-sidebar-scroll">
                            <StorageConfig
                                _getStorageInfo={this._getStorageInfo}
                                openConfiguration={this.state.openConfiguration}
                                _toggleopenConfiguration={this._toggleopenConfiguration}
                                height={this.state.height}
                            />
                        </div>

                        <div className="sm-sidebar-tip">
                            <div className="sm-sidebar-tip-box">
                                <p>Select a connection above to browse files. Use <strong>Trash</strong> below to review deleted items.</p>
                            </div>
                        </div>

                        <div className="sm-sidebar-nav">
                            <button
                                type="button"
                                className={`sm-sidebar-nav-item${trashFileFlag ? " trash-active" : ""}`}
                                onClick={() =>
                                    this.setState({
                                        trashFileFlag: !trashFileFlag,
                                        prefixCurrent: "",
                                    })
                                }
                            >
                                {!trashFileFlag ? (
                                    <>
                                        <i className="fas fa-trash-alt" />
                                        <span>Trash</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="fa-solid fa-arrow-left" />
                                        <span>Back to files</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </aside>
                )}

                {/* ── Main ── */}
                <div className="sm-main">
                    {/* Top bar */}
                    <div className="sm-topbar">
                        <div className="sm-page-header-left">
                            <div className="sm-topbar-title">
                                <h1>
                                    {trashFileFlag
                                        ? "Trash"
                                        : this.state.storageName
                                        ? this.state.storageName
                                        : "Files"}
                                </h1>
                                <p>{this._pageHeaderSubtitle()}</p>
                            </div>
                        </div>

                        {messageInfo && (
                            <div className="sm-message-toast">
                                <i className="fas fa-check-circle" />
                                <span title={messageInfo}>{messageInfo}</span>
                            </div>
                        )}

                        <div className="sm-topbar-actions">
                            <div className="sm-view-toggle" role="group" aria-label="View options">
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip id="tt-list">List view</Tooltip>}
                                >
                                    <button
                                        type="button"
                                        className={defaultView === 1 ? "active" : ""}
                                        onClick={() => this.selectViewType(1)}
                                        aria-pressed={defaultView === 1}
                                        aria-label="List view"
                                    >
                                        <i className="fas fa-th-list" />
                                    </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip id="tt-grid">Grid view</Tooltip>}
                                >
                                    <button
                                        type="button"
                                        className={defaultView === 2 ? "active" : ""}
                                        onClick={() => this.selectViewType(2)}
                                        aria-pressed={defaultView === 2}
                                        aria-label="Grid view"
                                    >
                                        <i className="fas fa-th-large" />
                                    </button>
                                </OverlayTrigger>
                            </div>

                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id="tt-expand">
                                        {expand ? "Show sidebar" : "Focus mode"}
                                    </Tooltip>
                                }
                            >
                                <button
                                    type="button"
                                    className="sm-expand-btn"
                                    onClick={this.expandView}
                                    aria-pressed={expand}
                                >
                                    <i className={`fa-solid ${expand ? "fa-minimize" : "fa-expand"}`} />
                                    <span>{expand ? "Sidebar" : "Focus"}</span>
                                </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="tt-close-storage">Leave storage and return to Apps</Tooltip>}
                            >
                                <Link to="/apps" className="sm-close-storage" aria-label="Close storage">
                                    <i className="fa-solid fa-xmark" aria-hidden="true" />
                                    <span>Close</span>
                                </Link>
                            </OverlayTrigger>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="sm-content">
                        <div className="sm-content-panel">
                            {storageId ? (
                                <StorageListView
                                    _getSelectedFiles={this._getSelectedFiles}
                                    showSelectBox={true}
                                    selectFromLocation={"input"}
                                    viewType={defaultView}
                                    actionFooter={false}
                                    storageId={this.state.storageId}
                                    storageName={this.state.storageName}
                                    cloudType={this.state.cloudType}
                                    rootFolder={this.state.rootFolder}
                                    prefixCurrent={this.state.prefixCurrent}
                                    selectedData={this.state.selectedData}
                                    trashFileFlag={trashFileFlag}
                                    _setCommonMessage={this._setCommonMessage}
                                    height={this.state.height}
                                />
                            ) : (
                                <div className="sm-empty">
                                    <div className="sm-empty-icon" aria-hidden="true">
                                        <i className="fa-solid fa-cloud" />
                                    </div>
                                    <h3>No storage connected</h3>
                                    <p>
                                        Add a storage configuration — S3, GCS, Azure, and more — then select it from the sidebar to start browsing.
                                    </p>
                                    <button
                                        type="button"
                                        className="sm-btn-primary"
                                        onClick={this.onClickAddConfiguration}
                                    >
                                        <i className="fas fa-plus" />
                                        <span>Add storage</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StorageMain;